import React from 'react';
import { Box } from '@mui/material';
import { AttachmentComponent } from '@ui-lib/components/AttachmentsViewer/components/AttachmentsList';
import { createSx } from '@ui-lib/utils';
import { BolPhotoAttachment } from '../types';

const sx = createSx({
  container: {
    mt: 2,
    objectFit: 'contain',
    width: '100%',
    maxHeight: {
      xs: '300px',
      sm: '400px',
      md: '500px',
      lg: '600px',
      xl: '700px'
    },
    bgcolor: 'black',
    borderRadius: 1,
  }
});

const PhotoItem: AttachmentComponent<BolPhotoAttachment> = ({ attachment, onClick }) => {
  return (
    <Box
      component='img'
      src={attachment.url}
      sx={sx.container}
      onClick={onClick}
    />
  );
};

export default PhotoItem;
